(function ($) {
    var header_placeholder = $('.header-placeholder');
    var header = $(header_placeholder).find('.header');
    var top_offset_for_scrolled = 240;
    var sentinel = insertSentinel();


    function adjust_header_placeholder() {
        $(header).height('');

        $(header_placeholder).height($(header).outerHeight());
    }

    adjust_header_placeholder();

    $(window).on('resize', function () {
        adjust_header_placeholder();
    });

    $(window).on('close-mobile-menu', function () {
        adjust_header_placeholder();
    });

    function insertSentinel() {
        var sentinel_element = $('<div class="sticky-sentinel"></div>');

        $(sentinel_element).css({
            position: 'absolute',
            visibility: 'hidden',
            width: '1px',
            height: '1px',
            left: '0',
            top: top_offset_for_scrolled
        }).appendTo('body');

        return sentinel_element[0];
    }
})(jQuery);